import React from "react";
import Card from "../../components/Card";

export default function Experiments() {
  const noOfExperiments = 13;
  let arr = new Array(noOfExperiments);
  arr.fill(1);
  let i = 0;
  return (
    <>
      <div className="container mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 pt-6 gap-8">
        {arr.map((a) => {
          return <Card number={i++} key={i} />;
        })}
      </div>
    </>
  );
}
